import styled from 'styled-components'

export const MainInfoCard = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 8px;
  position: relative;
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
  scroll-behavior: smooth;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;

  ${({ mobileFormat, theme }) =>
    !mobileFormat &&
    `@media (min-width: ${theme.screen.xlMin}) {
    flex-direction: column;
    justify-content: center;
  }`}
`

export const Company = styled('span')`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-word;
  flex-shrink: 1;
  min-width: 0;
`

export const CardHeader = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  height: ${({ hasLogo }) => (hasLogo ? '44px' : 'auto')};
  width: 100%;
  gap: 8px;
`

export const LogoWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #c5cee0;
  width: 68px;
  height: 44px;
  background: white;
  overflow: hidden;
`

export const Logo = styled('img')`
  width: 68px;
  height: 44px;
  transition: all 0.3s ease-in-out;
`

export const Title = styled('span')`
  display: flex;
  flex-direction: row;
  transition: all 0.3s ease-in-out;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
  padding-right: ${({ withIcon }) => `${withIcon ? 30 : 0}px`};

  ${({ mobileFormat, theme }) =>
    !mobileFormat &&
    `@media (min-width: ${theme.screen.xlMin}) {
    -webkit-line-clamp: 1;
    padding-right: 0px;
  }`}
`

export const Description = styled('span')`
  margin: 0px;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ clamp }) => clamp || 2};
  overflow: hidden;
  word-break: break-word;

  ${({ mobileFormat, theme }) =>
    !mobileFormat &&
    `@media (min-width: ${theme.screen.xlMin}) {
    max-height: 52px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
  }`}
`

export const DataRowTitle = styled('div')`
  display: flex;
  align-items: flex-start;
  margin: 0px;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding-right: 0px;
  padding-left: 0px;
  scroll-behavior: smooth;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  gap: 4px 8px;

  ${({ mobileFormat, theme }) =>
    !mobileFormat &&
    `@media (min-width: ${theme.screen.xlMin}) {
      flex-direction: row;
      align-items: center;

      &:not(:last-child) {
        margin-bottom: 12px;
      }
  }`}
`

export const CardBody = styled('div')`
  display: flex;
  flex-direction: column;
`

export const HeaderCol = styled('div')`
  position: relative;
  width: 100%;
  padding-right: 0px;
  padding-left: 0px;
  scroll-behavior: smooth;
  flex-basis: 0;
  flex-grow: 1;
  align-content: center;
  max-width: ${({ hasLogo }) => (!hasLogo ? '100%' : 'calc(100% - 70px);')};
`

export const HeaderContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ mobileFormat, theme, tipoAviso }) =>
    !mobileFormat &&
    `@media (min-width: ${theme.screen.xlMin}) {
    display: flex;
    height: 100%;
    align-items: center;
    border-right: ${tipoAviso === 'freemium' ? theme.colors.grey24 : theme.colors.secondary.ultraLighten}
      1px solid;
  }`}
`

export const ClampText = styled('div')`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const DateRow = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`

export const RowGap = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

export const HeaderColContainer = styled('div')`
  width: 100%;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DataColMobile = styled('div')`
  position: relative;
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
  -webkit-scroll-behavior: smooth;
  -moz-scroll-behavior: smooth;
  -ms-scroll-behavior: smooth;
  scroll-behavior: smooth;
`

export const TitleRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
`
